import { render } from "./StreetmetricsLogo.vue?vue&type=template&id=2654e36f"
import script from "./StreetmetricsLogo.vue?vue&type=script&lang=js"
export * from "./StreetmetricsLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__